var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circlechart"},[_c('div',{staticClass:"circlechart__svg",attrs:{"id":'circlechart--' + this._uid}}),_vm._v(" "),(_vm.valueExists())?_c('div',{staticClass:"circlechart__value"},[_vm._v(_vm._s(_vm.getFixedValue(_vm.value)))]):_c('div',{staticClass:"circlechart__value"},[_vm._v("N/A")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cf57ce2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/charts/CircleChart.vue
// module id = 392
// module chunks = 0